import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import numeral from 'numeral';
import moment from 'moment';
import { SanitizeHtml, SmoothLink, Sticky, GoogleMapUrl } from '@bd/bdcore-utilities';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import LightBox from '@bd/bdui-lightbox';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import CoreMap from '@bd/bdui-coremap';
// import SchoolList from '@bd/bdui-schoollist';
import ContactModal from '../../components/ContactModal';
import PageWrapper from '../../components/PageWrapper';
import AccordionToggle from '../../components/AccordionToggle';
import Carousel from '../../components/Carousel';
import { colors, typography } from '../../styles';

import HMLSDisclaimer from './HMLSDisclaimer';

const styles = css`
  position:relative;
  z-index: 0;
  .Breadcrumbs_wrapper {
    background-color: ${colors.color2};
    padding: 70px 15px 10px 15px;
    @media (min-width: 992px) {
      padding: 115px 60px 15px 30px;
    }
  }
  .Breadcrumbs_list {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .Breadcrumbs_listItem {
    display: inline-block;
    margin: 0;
    font-size: 14px;
    color: #FFFFFF;
    &:after {
      content: '/';
      margin: 0 5px;
      display: inline-block;
    }
    &:last-child:after {
      display: none;
    }
    a {
      color: #FFFFFF;
      font-weight: bold;
    }
  }
  .DetailHeader {
    @media (min-width: 992px) {
      padding: 60px 0;
      background-color: #F5F5F5;
      margin: 0 0 30px 0;
    }
  }

  .DetailHeader_content {
    position: relative;
    margin: 0 -15px;
    @media (min-width: 992px) {
      margin: 0;
    }
    h1 {
      font-weight: 700;
      font-size: 20px;
      line-height: 18px;
      margin: 0;
      padding: 15px 15px;
      color: ${colors.color1};
      span {
        font-size: 15px;
        font-weight: 400;
      }
      @media (min-width: 992px) {
        font-size: 24px;
        line-height: 24px;
        border-bottom: 1px solid ${colors.color2};
        padding: 0 45px 15px 0;
        margin: 0 0 25px 0;
        span {
          font-size: 18px;
        }
      }
    }
  }
  .DetailHeader_contentMapButton {
    position: absolute;
    right: 15px;
    top: 8px;
    background-image: url('/images/icon-map-pin-site.svg');
    display: block;
    width: 30px;
    height: 40px;
    padding: 21px 0 0 0;
    background-size: 14px 25px;
    background-repeat: no-repeat;
    background-position: top center;
    text-align: center;
    color: ${colors.color1};
    font-size: 12px;
    font-weight: 700;
    @media (min-width: 992px) {
      right: 0;
    }
  }
  .DetailHeader_iconList {
    display: flex;
    list-style: none;
    margin: 0 0 25px 0;
    padding: 0 15px;
    @media (min-width: 992px) {
      padding: 0;
      margin: 0 0 25px 0;
    }
    li {
      font-size: 15px;
      line-height: 1;
      margin: 0 15px 0 0;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      @media (min-width: 1200px) {
        font-size: 16px;
        margin: 0 20px 0 0;
      }
    }
  }
  .DetailHeader_iconListIcon {
    display: inline-block;
    vertical-align: middle;
    margin: -2px 8px 5px 0;
    img {
      height: 14px;
      width: auto;
      @media (min-width: 1200px) {
        height: 21px;
      }
    }
  }
  .DetailHeader_iconListItemValue {
    font-weight: 700;
    margin: ;
  }
  .DetailHeader_priceWrapper {
    padding: 0 15px;
    margin: 0 0 15px 0;
    @media (min-width: 992px) {
      padding: 0;
    }
  }
  .DetailHeader_priceValue {
    font-size: 20px;
    color: ${colors.color2};
    font-weight: 700;
    margin: 0;
    @media (min-width: 992px) {
      font-size: 24px;
    }
  }
  .DetailHeader_priceMonthly {
    font-size: 14px;
    font-weight: 300;
    font-style: italic;
    margin-left: 5px;
    @media (min-width: 992px) {
      display: block;
      padding: 10px 15px;
      background-color: #FFFFFF;
      font-size: 18px;
      font-weight: 700;
      font-style: normal;
      margin: 15px 0 20px 0;
      color: ${colors.color2};
    }
  }
  .DetailHeader_buttonsWrapper {
    padding: 0 15px;
    margin: 0 0 30px 0;
    @media (min-width: 992px) {
      padding: 0;
    }
    span:focus {
      outline: none;
      box-shadow: none;
    }
  }
  .DetailHeader_iconButtonsList {
    list-style: none;
    display: flex;
    justify-content: space-between;
    padding: 0;
    padding: 0 15px;
    @media (min-width: 992px) {
      padding: 0;
    }
  }
  .DetailHeader_iconButtonsListItem {
    text-align: center;
    width: 65px;
    @media (min-width: 1600px) {
      width: 85px;
    }
  }
  .DetailHeader_iconButtonsListItemIcon {
    width: 55px;
    height: 55px;
    background-color: ${colors.color1};
    border-radius: 50%;
    padding-top: 15px;
    text-align: center;
    margin: 0 auto 5px auto;
    @media (min-width: 1600px) {
      width: 75px;
      height: 75px;
      padding-top: 23px;
    }
    img {
      height: 21px;
      @media (min-width: 1600px) {
        height: 28px;
      }
    }
  }
  .DetailHeader_iconButtonsListItemLabel {
    font-size: 12px;
    color: ${colors.color1};
    @media (min-width: 1600px) {
      font-size: 14px;
    }
  }
  .DetailMenu {
    display: none;
    @media (min-width: 992px) {
      display: block;
      background-color: #FFFFFF;
      border-bottom: 1px solid ${colors.color2};
    }
  }
  .DetailMenu_list {
    list-style: none;
    padding: 0;
    margin: 0;
    text-align: center;
  }
  .DetailMenu_listItem {
    display: inline-block;
    a {
      display: block;
      font-weight: 700;
      font-size: 18px;
      padding: 0 20px;
      line-height: 58px;
      height: 58px;
      transition: all .3s ease;
      border-bottom: 6px solid #FFFFFF;
      color: #666666;
      &:hover {
        opacity: 1;
        color: ${colors.color2};
      }
    }
    & a.active {
      color: ${colors.color2};
      border-bottom: 6px solid ${colors.color2};
      opacity: 1;
    }

  }
  .DetailSection {
    position: relative;
    .ScrollTarget {
      position: absolute;
      display: block;
      top: -110px;
    }
  }
  .DetailSection_heading {
    color: ${colors.color1};
    padding: 15px 0;
    background-image: url('/images/icon-plus-blue.svg');
    background-position: calc(100% - 5px) center;
    background-repeat: no-repeat;
    background-size: 10px 10px;
    border-top: 1px solid #eeeeee;
    font-size: 18px;
    outline: 0 !important;
    margin: 0;
    @media (min-width: 992px) {
      font-family: ${typography.Serif};
      font-size: 32px;
      border: 0;
      padding: 45px 0 15px 0;
      background-image: none;
    }
  }
  .DetailSection_heading-open {
    background-image: url('/images/icon-minus-blue.svg');
    margin: 0 0 20px 0;
  }
  .DetailSection:last-child {
    .DetailSection_heading {
      border-bottom: 1px solid #eeeeee;
      margin: 0 0 45px 0;
    }
  }
  .DetailSection_featuresImage {
    background-color: #CCCCCC;
    height: 100%;
    @media (min-width: 992px) {
      padding: 0;
      min-height: 300px;
    }
  }
  .DetailSection_featuresHeading {
    font-family: ${typography.Serif};
    color: ${colors.color1};
    font-size: 24px;
    margin: 0 0 15px 0;
  }
  .DetailSection_featuresContent {
    background-color: #F5F5F5;
    padding: 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    @media (min-width: 992px) {
      padding: 45px;
    }
  }
  .DetailSection_featuresList {
    padding: 0;
    margin: 0 0 0 20px;
    font-size: 18px;
  }
  .DetailSection_featuresListItem {
    margin: 0 0 8px 0;
  }
  .DetailSection_table, .SchoolList_list {
    list-style: none;
    padding: 0;
    padding-bottom: 45px;
    li:last-child {
      border-bottom: 1px solid #EEEEEE;
    }
  }
  .SchoolList_school {
    display: flex;
  }
  .DetailSection_tableLabel, .SchoolList_schoolLevel {
    background-color: #F5F5F5;
    border-top: 1px solid #EEEEEE;
    padding: 10px 10px;
    font-weight: 700;
    font-size: 15px;
    height: 100%;
    @media (min-width: 992px) {
      font-size: 16px;
      padding: 15px 15px;
    }
  }
  .SchoolList_schoolLevel {
    width: 33.3333%;
    flex-grow: 0;
  }
  .DetailSection_tableContent, .SchoolList_schoolName {
    border-top: 1px solid #EEEEEE;
    padding: 10px 10px;
    font-size: 15px;
    height: 100%;
    display: block;
    @media (min-width: 992px) {
      font-size: 16px;
      padding: 15px 45px;
    }
  }
  .SchoolList_schoolName {
    width: 66.6666%;
    flex-grow: 0;
  }
  .ModelHours {
    padding: 15px;
  }
`;

const videoLightBoxStyle = css`
  position: relative;
  width: 80%;
  padding-top: calc(80% * 0.5625);
  margin-top: -22%;
  top: 50%;
  margin-left: 10%;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

function HomeDetail({ home, plan, community }) {
  const carouselSlides = [
    ...get(home, 'photos', []),
    ...get(home, 'elevationPhotos', []),
  ];

  if (get(home, 'tourUrl')) {
    carouselSlides.splice(1, 0, {
      type: 'tour',
      element: (<div className={`Carousel_imageElement ${videoLightBoxStyle}`}><iframe title="Virtual Tour" src={get(home, 'tourUrl')} /></div>),
    });
  }

  if (get(home, 'videos', []).length) {
    carouselSlides.splice(1, 0, ...get(home, 'videos', []).map(video => ({
      type: 'video',
      element: (<div className={`Carousel_imageElement ${videoLightBoxStyle}`} dangerouslySetInnerHTML={SanitizeHtml(video)} />),
    })));
  }
  return (
    <PageWrapper>
      <PageHelmet home={home} />
      <div className={styles}>
        <div className="Breadcrumbs_wrapper">
          <ul className="Breadcrumbs_list">
            <li className="Breadcrumbs_listItem"><Link name="homes">Homes</Link></li>
            <li className="Breadcrumbs_listItem">{get(home, 'address.streetAddress')}</li>
          </ul>
        </div>

        <div className="DetailHeader">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 p-0 px-sm-3">
                <Carousel
                  items={carouselSlides}
                  thumbnails
                  mainImageProps={{
                    width: 2000,
                    height: 1125,
                    exact: true,
                  }}
                  thumbnailImageProps={{
                    width: 475,
                    height: 267,
                    exact: true,
                  }}
                />
              </div>
              <div className="col-lg-4">
                <div className="DetailHeader_content">
                  <h1>
                    {get(home, 'address.streetAddress')}<br />
                    <span>
                      {get(home, 'address.addressLocality')}, {get(home, 'address.addressRegion')} {get(home, 'address.postalCode')}
                    </span>
                    {
                      get(home, 'mls') &&
                      <span>
                        <br />MLS Number: {get(home, 'mls')}
                      </span>
                    }
                  </h1>
                  <SmoothLink href="#map">
                    <div className="DetailHeader_contentMapButton">
                      Map
                    </div>
                  </SmoothLink>

                  {
                    get(home, 'isModel') && get(home, 'isModelHours') &&
                    <div className="ModelHours">
                      Model Hours:<br />{get(home, 'isModelHours')}
                    </div>
                  }

                  <ul className="DetailHeader_iconList">
                    {
                      get(home, 'beds') &&
                      <li>
                        <span className="DetailHeader_iconListIcon"><img src="/images/icon-beds.svg" alt="" /></span>
                        <div className="d-flex flex-column">
                          <span className="DetailHeader_iconListItemValue ">{get(home, 'beds')}</span>
                          <span> Beds</span>
                        </div>
                      </li>
                    }
                    {
                      get(home, 'bathsFull') &&
                      <li>
                        <span className="DetailHeader_iconListIcon"><img src="/images/icon-baths.svg" alt="" /></span>
                        <div className="d-flex flex-column">
                          <span className="DetailHeader_iconListItemValue ">{get(home, 'bathsFull')}{get(home, 'bathsHalf', 0) > 0 && '.5'}</span>
                          <span> Baths</span>
                        </div>
                      </li>
                    }
                    {
                      get(home, 'sqft') &&
                      <li>
                        <span className="DetailHeader_iconListIcon"><img src="/images/icon-sqft.svg" alt="" /></span>
                        <div className="d-flex flex-column">
                          <span className="DetailHeader_iconListItemValue ">{numeral(get(home, 'sqft')).format('0,0')}</span>
                          <span> SQ FT</span>
                        </div>
                      </li>
                    }
                  </ul>
                  {
                    (
                      get(home, 'price')
                      || get(home, 'monthlyPrice')
                    ) &&
                    <div className="DetailHeader_priceWrapper">
                      {
                        get(home, 'monthlyPrice') &&
                        <span className="DetailHeader_priceMonthly">Payments from {numeral(get(home, 'monthlyPrice')).format('$0')}/month*</span>
                      }
                      {
                        get(home, 'price') &&
                        <span className="DetailHeader_priceValue">{numeral(get(home, 'price')).format('$0,0')}</span>
                      }
                    </div>
                  }
                  <div className="DetailHeader_buttonsWrapper">
                    <div className="row">
                      <div className="col-6">
                        <ContactModal>
                          <div className="btn btn-block">Check Availability</div>
                        </ContactModal>
                      </div>
                      {
                        get(home, 'custom_floor_plans') &&
                        <div className="col-6">
                          <a
                            href={get(home, 'custom_floor_plans.contentUrl')}
                            rel="naopener noreferrer"
                            className="btn btn-block"
                          >
                            Floor Plan Brochure
                          </a>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Sticky style={{ zIndex: 100, top: 100 }}>
          <div className="DetailMenu">
            <div className="container">
              <ul className="DetailMenu_list">
                {
                  get(home, 'floorplanPhotos', []).length > 0 &&
                  <li className="DetailMenu_listItem"><SmoothLink href="#plan">Floor Plan</SmoothLink></li>
                }
                {
                  get(home, 'description') &&
                  <li className="DetailMenu_listItem"><SmoothLink href="#description">Description</SmoothLink></li>
                }
                <li className="DetailMenu_listItem"><SmoothLink href="#specifications">Specifications</SmoothLink></li>
                {/* {
                  get(community, 'schools', []).length > 0 &&
                  <li className="DetailMenu_listItem">
                  <SmoothLink href="#schools">Schools</SmoothLink></li>
                } */}
                <li className="DetailMenu_listItem"><SmoothLink href="#map">Map & Directions</SmoothLink></li>
              </ul>
            </div>
          </div>
        </Sticky>

        {
          get(home, 'floorplanPhotos', []).length > 0 &&
          <div className="DetailSection">
            <div className="ScrollTarget" id="plan" />
            <AccordionToggle
              openOnId="plan"
              button={({ contentVisible }) => (
                <div className="container">
                  <h3 className={`DetailSection_heading ${contentVisible && 'DetailSection_heading-open'}`}>Floor Plan</h3>
                </div>
              )}
              onClick={() => moveTo('#plans')}
            >
              <div className="DetailSection_content">
                <div className="container">
                  <LightBox
                    items={get(home, 'floorplanPhotos', [])}
                  >
                    <div className="row">
                      {
                          get(home, 'floorplanPhotos', []).map((photo, index) => (
                            <div className="col-lg-6" key={photo.contentUrl}>
                              <img className="w-100 mb-4 border" data-index={index} src={get(photo, 'contentUrl')} alt={get(photo, 'caption')} />
                            </div>
                          ))
                        }
                    </div>
                  </LightBox>
                </div>
              </div>
            </AccordionToggle>
          </div>
        }
        {
          get(home, 'description') &&
          <div className="DetailSection">
            <div className="ScrollTarget" id="description" />
            <AccordionToggle
              openOnId="description"
              button={({ contentVisible }) => (
                <div className="container">
                  <h3 className={`DetailSection_heading ${contentVisible && 'DetailSection_heading-open'}`}>Description</h3>
                </div>
              )}
            >
              <div className="container">
                <div className="row py-4">
                  <div className={`mb-4 ${get(home, 'custom_details')} ? col-lg-6 : col-12`}>
                    <div dangerouslySetInnerHTML={SanitizeHtml(get(home, 'description'))} />
                  </div>
                  {
                    get(home, 'custom_details') &&
                    <div className="col-lg-6 mb-4">
                      <h5>Custom Details</h5>
                      <div dangerouslySetInnerHTML={SanitizeHtml(get(home, 'custom_details'))} />
                    </div>
                  }
                </div>
              </div>
            </AccordionToggle>
          </div>
        }
        <div className="DetailSection">
          <div className="ScrollTarget" id="specifications" />
          <AccordionToggle
            openOnId="specifications"
            button={({ contentVisible }) => (
              <div className="container">
                <h3 className={`DetailSection_heading ${contentVisible && 'DetailSection_heading-open'}`}>Specifications</h3>
              </div>
            )}
          >
            <div className="container">
              <ul className="DetailSection_table">
                <li className="row">
                  <div className="col-4 pr-0">
                    <div className="DetailSection_tableLabel">
                      Address
                    </div>
                  </div>
                  <div className="col-8 pl-0">
                    <div className="DetailSection_tableContent">
                      { get(home, 'address.streetAddress') }
                    </div>
                  </div>
                </li>
                <li className="row">
                  <div className="col-4 pr-0">
                    <div className="DetailSection_tableLabel">
                      City, St, Zip
                    </div>
                  </div>
                  <div className="col-8 pl-0">
                    <div className="DetailSection_tableContent">
                      {`${get(home, 'address.addressLocality')}, ${get(home, 'address.addressRegion')} ${get(home, 'address.postalCode')}`}
                    </div>
                  </div>
                </li>
                {
                  get(home, 'beds') > 0 &&
                  <li className="row">
                    <div className="col-4 pr-0">
                      <div className="DetailSection_tableLabel">
                        Bedrooms
                      </div>
                    </div>
                    <div className="col-8 pl-0">
                      <div className="DetailSection_tableContent">
                        {get(home, 'beds')}
                      </div>
                    </div>
                  </li>
                }
                {
                  get(home, 'bathsFull') > 0 &&
                  <li className="row">
                    <div className="col-4 pr-0">
                      <div className="DetailSection_tableLabel">
                        Full Baths
                      </div>
                    </div>
                    <div className="col-8 pl-0">
                      <div className="DetailSection_tableContent">
                        {get(home, 'bathsFull')}
                      </div>
                    </div>
                  </li>
                }
                {
                  get(home, 'bathsHalf') > 0 &&
                  <li className="row">
                    <div className="col-4 pr-0">
                      <div className="DetailSection_tableLabel">
                        Half Baths
                      </div>
                    </div>
                    <div className="col-8 pl-0">
                      <div className="DetailSection_tableContent">
                        {get(home, 'bathsHalf')}
                      </div>
                    </div>
                  </li>
                }
                {
                  get(home, 'sqft') > 0 &&
                  <li className="row">
                    <div className="col-4 pr-0">
                      <div className="DetailSection_tableLabel">
                        Sq Ft
                      </div>
                    </div>
                    <div className="col-8 pl-0">
                      <div className="DetailSection_tableContent">
                        {numeral(get(home, 'sqft')).format('0,0')}
                      </div>
                    </div>
                  </li>
                }
                {
                  get(home, 'price') > 10000 &&
                  <li className="row">
                    <div className="col-4 pr-0">
                      <div className="DetailSection_tableLabel">
                        Price
                      </div>
                    </div>
                    <div className="col-8 pl-0">
                      <div className="DetailSection_tableContent">
                        {numeral(get(home, 'price')).format('$0,0')}
                      </div>
                    </div>
                  </li>
                }
                {
                  get(home, 'moveInDate') &&
                  <li className="row">
                    <div className="col-4 pr-0">
                      <div className="DetailSection_tableLabel">
                        Estimated Completion Date
                      </div>
                    </div>
                    <div className="col-8 pl-0">
                      <div className="DetailSection_tableContent">
                        {moment(get(home, 'moveInDate')).format('MMMM D, YYYY')}
                      </div>
                    </div>
                  </li>
                }
                {
                  get(community, 'name') &&
                  <li className="row">
                    <div className="col-4 pr-0">
                      <div className="DetailSection_tableLabel">
                        Community
                      </div>
                    </div>
                    <div className="col-8 pl-0">
                      <div className="DetailSection_tableContent">
                        {get(community, 'name')}
                      </div>
                    </div>
                  </li>
                }
                {
                  get(plan, 'name') &&
                  <li className="row">
                    <div className="col-4 pr-0">
                      <div className="DetailSection_tableLabel">
                        Plan
                      </div>
                    </div>
                    <div className="col-8 pl-0">
                      <div className="DetailSection_tableContent">
                        {get(plan, 'name')}
                      </div>
                    </div>
                  </li>
                }
                {
                  get(home, 'builder_name') &&
                  <li className="row">
                    <div className="col-4 pr-0">
                      <div className="DetailSection_tableLabel">
                        Builder
                      </div>
                    </div>
                    <div className="col-8 pl-0">
                      <div className="DetailSection_tableContent">
                        {get(home, 'builder_name')}
                      </div>
                    </div>
                  </li>
                }
                {
                  get(home, 'status') &&
                  <li className="row">
                    <div className="col-4 pr-0">
                      <div className="DetailSection_tableLabel">
                        Status
                      </div>
                    </div>
                    <div className="col-8 pl-0">
                      <div className="DetailSection_tableContent">
                        {get(home, 'status')}
                      </div>
                    </div>
                  </li>
                }
                {
                  get(home, 'lot') &&
                  <li className="row">
                    <div className="col-4 pr-0">
                      <div className="DetailSection_tableLabel">
                        Lot
                      </div>
                    </div>
                    <div className="col-8 pl-0">
                      <div className="DetailSection_tableContent">
                        {get(home, 'lot')}
                      </div>
                    </div>
                  </li>
                }
                {
                  get(home, 'lotSize') &&
                  <li className="row">
                    <div className="col-4 pr-0">
                      <div className="DetailSection_tableLabel">
                        Lot Size
                      </div>
                    </div>
                    <div className="col-8 pl-0">
                      <div className="DetailSection_tableContent">
                        {numeral(get(home, 'lotSize')).format('0,0')} Sq Ft
                      </div>
                    </div>
                  </li>
                }
                {
                  get(home, 'mls') &&
                  <li className="row">
                    <div className="col-4 pr-0">
                      <div className="DetailSection_tableLabel">
                        MLS
                      </div>
                    </div>
                    <div className="col-8 pl-0">
                      <div className="DetailSection_tableContent">
                        #{get(home, 'mls')}
                      </div>
                    </div>
                  </li>
                }
                {
                  get(home, 'garages') > 0 &&
                  <li className="row">
                    <div className="col-4 pr-0">
                      <div className="DetailSection_tableLabel">
                        Garages
                      </div>
                    </div>
                    <div className="col-8 pl-0">
                      <div className="DetailSection_tableContent">
                        {get(home, 'garages')}-Car
                      </div>
                    </div>
                  </li>
                }
                {
                  get(home, 'masterBedLocation') &&
                  <li className="row">
                    <div className="col-4 pr-0">
                      <div className="DetailSection_tableLabel">
                        Master Bedroom Location
                      </div>
                    </div>
                    <div className="col-8 pl-0">
                      <div className="DetailSection_tableContent">
                        {get(home, 'masterBedLocation') === 'up' ? 'Upstairs' : 'Main Floor'}
                      </div>
                    </div>
                  </li>
                }
              </ul>
            </div>
          </AccordionToggle>
        </div>
        {/* <div className="DetailSection">
          <div className="ScrollTarget" id="schools" />
          <AccordionToggle
            openOnId="schools"
            button={({ contentVisible }) => (
              <div className="container">
                <h3 className={`DetailSection_heading
                ${contentVisible && 'DetailSection_heading-open'}`}>Schools</h3>
              </div>
            )}
          >
            <div className="container">
              <SchoolList schools={get(community, 'schools', [])} />
            </div>
            {/* <ul className="container DetailSection_table">
              {
                get(community, 'schools', []).length &&
                get(community, 'schools').map(school => (
                  <li className="row" key={school.name}>
                    <div className="col-4 pr-0">
                      <div className="DetailSection_tableLabel">
                        {school.type}
                      </div>
                    </div>
                    <div className="col-8 pl-0">
                      <div className="DetailSection_tableContent">
                        {school.name}
                      </div>
                    </div>
                  </li>
                ))
              }
            </ul>
          </AccordionToggle>
        </div> */}
        <div className="DetailSection">
          <div className="ScrollTarget" id="map" />
          <AccordionToggle
            openOnId="map"
            button={({ contentVisible }) => (
              <div className="container">
                <h3 className={`DetailSection_heading ${contentVisible && 'DetailSection_heading-open'}`}>Map & Directions</h3>
              </div>
            )}
          >
            <div className="container pb-5">
              <div className="row pb-5">
                <div className="col-lg-8">
                  <CoreMap
                    pin={{
                      iconUrl: '/images/icon-map-pin-site.svg',
                      iconSize: [32, 46],
                      iconAnchor: [16, 46],
                    }}
                    className={css`
                      position: relative;
                      padding-bottom: 56.25%;
                      width: 100%;
                      z-index: 0;

                      background-color: ${colors.color3};
                      .leaflet-container {
                        position: absolute;
                        top: 0;
                        bottom: 0;
                        left: 0;
                        right: 0;
                      }
                    `}
                    markers={[home]}
                  />
                </div>
                <div className="col-lg-4">
                  <div className="mb-3 ">
                    {get(home, 'directions')}
                  </div>
                  <div className="text-center">
                    <a href={GoogleMapUrl(home)} target="_blank" rel="noopener noreferrer">
                      <img src="/images/icon-map-pin-site.svg" alt="" /> View on Google Map
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </AccordionToggle>
          <div className="container pb-5">
            <div className="row pb-5">
              <div className="col">
                <HMLSDisclaimer home={home} />
              </div>
            </div>
          </div>
        </div>
      </div>

    </PageWrapper>
  );
}

HomeDetail.propTypes = {
  home: PropTypes.object.isRequired,
  plan: PropTypes.object,
  community: PropTypes.object,
};

HomeDetail.defaultProps = {
  community: undefined,
  plan: undefined,
};

export default withData(
  {
    home: true,
    community: true,
    plan: true,
  },
  {
    required: {
      home: true,
    },
    ifMissing404: true,
  },
)(HomeDetail);



// WEBPACK FOOTER //
// ./src/pages/HomeDetail/index.js